export const REQUEST_EXPERTISE_MISSIONS = 'REQUEST_EXPERTISE_MISSIONS';
export const SET_EXPERTISE_MISSIONS = 'SET_EXPERTISE_MISSIONS';
export const REQUEST_UPDATE_MISSION_MANAGER = 'REQUEST_UPDATE_MISSION_MANAGER';
export const REQUEST_GET_CLAIM_INFO = 'REQUEST_GET_CLAIM_INFO';
export const SET_CLAIM_INFO = 'SET_CLAIM_INFO';
export const RESET_STORE_EXPERTISE = 'RESET_STORE_EXPERTISE';
